var _path, _path2, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#175CFA",
    d: "M.921 5.426C1.347 3.117 3.127 1.381 5.437.96A59.6 59.6 0 0 1 16 0c4.303 0 8.025.495 10.581.963 2.3.42 4.074 2.145 4.5 4.443C31.534 7.861 32 11.48 32 16c0 4.627-.487 8.308-.952 10.765-.416 2.2-2.08 3.872-4.282 4.289C24.322 31.517 20.654 32 16 32c-4.643 0-8.304-.481-10.748-.943-2.212-.417-3.882-2.1-4.299-4.312C.488 24.277 0 20.59 0 16c0-4.486.466-8.108.921-10.574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFF",
    d: "M21.951 11.977H17.71V23.53h-3.418V11.977H10.05V9.055h11.902z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@media (prefers-color-scheme:light){:root{filter:none}}@media (prefers-color-scheme:dark){:root{filter:none}}")));
};
export default SvgLogo;